var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"text-2xl text-black font-thinn"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-black"},[_c('span',{staticClass:"text-3xl font-bold"})])
}]

export { render, staticRenderFns }